// extracted by mini-css-extract-plugin
export default {"account_subscription_card_body":"PW","account_subscription_card_img":"QW","account_subscription_card_lower_section":"RW","account_subscription_card_category":"SW","account_subscription_card_title":"TW","account_subscription_card_price_section":"UW","account_subscription_card_servings":"VW","account_subscription_card_prices":"WW","account_subscription_card_price":"XW","account_subscription_card_price_actual":"YW"};
    if(module.hot) {
      // 1713912567347
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  